export default function round(num: number, decimals: number): number {
  const pow = 10 ** decimals;
  return Math.round(num * pow) / pow;
}
